import { AfterViewInit, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import '@npm-bbta/bbog-dig-dt-webcomponents-lib';
import { BdbCifinConfrontaService } from './services/bdb-cifin-confronta.service';
import { CifinConfrontaQuestion } from './models/cifin-confronta-question';
import { Router } from '@angular/router';
import { BdbSessionStrgService } from '@npm-bbta/bbog-cm-auth-lib';
import { AnswerDto } from './models/answer-dto';
import WebcomponentParam from '../models/webcomponent-param';
import { ResponseFromFetch } from '../models/response-from-fetch.model';
import HttpStatusCode from '../enums/http-status.enum';
import { RedirectService } from '../shared/redirect.service';
import { environment } from '../../../environments/environment';
import { GoogleTagManagerService } from '../shared/google-tag-manager.service';
import { SessionStorageKeysEnum } from '../models/session-storage-keys-enum';
import {NewServiceErrorEnum} from '../enums/new-service-error.enum';

@Component({
    selector: 'app-bdb-cifin-confronta',
    templateUrl: './bdb-cifin-confronta.component.html',
    styleUrls: ['./bdb-cifin-confronta.component.scss']
})
export class BdbCifinConfrontaComponent implements OnInit, AfterViewInit {

    @ViewChild('bdbMlMultiActionElement') bdbMlMultiAction: ElementRef;
    @ViewChild('questionText') questionTextElement: ElementRef;
    @ViewChild('modalElement') modalElement: ElementRef;
    questionnaire: CifinConfrontaQuestion[];
    answers: AnswerDto[];
    index: number;
    currentConfrontaAttempt = 0;
    question: string;
    webComponentParams: WebcomponentParam[] = [];


    constructor(
        private readonly bdbCifinConfrontaService: BdbCifinConfrontaService,
        private readonly router: Router,
        private readonly bdbSessionStorageService: BdbSessionStrgService,
        private readonly redirectService: RedirectService,
        private readonly googleTagManagerService: GoogleTagManagerService,
    ) {
    }

    ngOnInit() {
        this.initQuestions();
    }

    ngAfterViewInit(): void {
        this.modalElement.nativeElement.openAlert();
    }

    initQuestions(): void {
        this.index = 0;
        this.googleTagManagerService.sendInfo(window.location.pathname, 'Preguntas de seguridad',
            {currentConfrontaAttempt: this.currentConfrontaAttempt + 1});
        this.bdbSessionStorageService.save(SessionStorageKeysEnum.CURRENT_CONFRONTA_ATTEMPT, String(this.currentConfrontaAttempt));

        this.bdbCifinConfrontaService.getQuestions().then((questionsFromService: CifinConfrontaQuestion[]) => {
            this.modalElement.nativeElement.handleCloseClick();
            this.currentConfrontaAttempt++;
            this.questionnaire = questionsFromService;
            this.getQuestion();
        }).catch((reason) => {
            this.bdbSessionStorageService.save(SessionStorageKeysEnum.ERROR_CODE, NewServiceErrorEnum.CONFRONTA_WRONG_ANSWERS);
            this.router.navigate(['error']);
            this.modalElement.nativeElement.handleCloseClick();
            console.error(reason);
        });
    }

    private getQuestion(): void {
        this.question = this.questionnaire[this.index].text;
        this.questionTextElement.nativeElement.innerHTML = this.question;
        this.questionTextElement.nativeElement.innerText = this.question;
        this.answers = this.questionnaire[this.index].answerDto;
        this.index++;
        this.handleAnswers();
    }

    selectedAnswer(event: any) {
        const selectedValue = event.detail;
        const selectedValueId = Number(selectedValue.value);
        this.answers[selectedValueId].selected = true;
        if (this.index < this.questionnaire.length) {
            this.getQuestion();
        } else {
            this.finishQuestionary();
        }
    }

    public finishQuestionary(): void {
        this.modalElement.nativeElement.openAlert();
        this.bdbCifinConfrontaService.checkAnswers(this.questionnaire).then((response: ResponseFromFetch) => {
            this.modalElement.nativeElement.handleCloseClick();
            const status = response.status;
            const successCheckAnswers = status === HttpStatusCode.OK;
            if (successCheckAnswers) {
                this.redirectService.redirectFromAuthentication();
            } else {
                this.checkReattempt();
            }
        }).catch((reason) => {
            this.modalElement.nativeElement.handleCloseClick();
            this.bdbSessionStorageService.save(SessionStorageKeysEnum.ERROR_CODE, NewServiceErrorEnum.CONFRONTA_WRONG_ANSWERS);
            this.router.navigate(['error']);
            console.error(reason);
        });
    }

    handleAnswers(): void {
        const webComponentsParams = [];
        this.answers.forEach((answer, answerIndex) => {
            const webComponentParam = new WebcomponentParam(
                String(answerIndex),
                answer.textAnswer,
                null,
                null,
            )
            webComponentsParams.push(webComponentParam)
        });
        console.log(this.webComponentParams);
        this.webComponentParams = webComponentsParams;
    }

    private checkReattempt(): void {
        if (this.currentConfrontaAttempt < environment.maxConfrontaAttempts) {
            this.initQuestions();
        } else {
            this.bdbSessionStorageService.save(SessionStorageKeysEnum.ERROR_CODE, NewServiceErrorEnum.CONFRONTA_WRONG_ANSWERS);
            this.router.navigate(['error']);
        }
    }

    backButtonClicked($event: any) {
        this.router.navigate(['second-factor-selector']);
    }

    closeButtonCLicked($event: any) {
        this.router.navigate(['identity-number']);
    }
}



// WEBPACK FOOTER //
// ./src/app/bdb-cifin-confronta/bdb-cifin-confronta.component.ts